export const COIN_FLIP_SOURCE_HANDLES = {
  heads: 'coin-flip-heads',
  tails: 'coin-flip-tails',
} as const;
